import React from 'react'
import defaultColors from '@constants/listColors'
import cx from 'classnames'
import { ColorWrap, Saturation, Hue } from 'react-color/lib/components/common'
import SketchFields from 'react-color/lib/components/sketch/SketchFields'
import SketchPresetColors from 'react-color/lib/components/sketch/SketchPresetColors'

export const SketchPickerWithButton = ({
  width,
  rgb,
  hex,
  hsv,
  hsl,
  onChange,
  onSwatchHover,
  disableAlpha,
  presetColors,
  styles: passedStyles = {},
  className = '',
}) => {
  return (
    <div
      style={{
        width,
        padding: 10,
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
      }}
      className={cx('sketch-picker', className)}
    >
      <div className="presetWrapper">
        <SketchPresetColors
          colors={presetColors}
          onClick={onChange}
          onSwatchHover={onSwatchHover}
        />
      </div>
      <div
        style={{
          width: '100%',
          paddingBottom: '75%',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Saturation
          style={{
            radius: '3px',
            shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)',
          }}
          hsl={hsl}
          hsv={hsv}
          onChange={onChange}
        />
      </div>
      <div
        style={{
          display: 'flex',
        }}
        className="flexbox-fix"
      >
        <div
          style={{
            padding: '4px 0',
          }}
        >
          <div
            style={{
              position: 'relative',
              height: '10px',
              overflow: 'hidden',
            }}
          >
            <Hue
              style={{
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)',
              }}
              hsl={hsl}
              onChange={onChange}
            />
          </div>
          <SketchFields
            rgb={rgb}
            hsl={hsl}
            hex={hex}
            onChange={onChange}
            disableAlpha={disableAlpha}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              marginLeft: 5,
              marginBottom: 21,
              height: 35,
              width: 25,
              borderRadius: '4px',
              background: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`,
              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)',
            }}
          />
        </div>
      </div>
    </div>
  )
}

SketchPickerWithButton.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: defaultColors,
}

export default ColorWrap(SketchPickerWithButton)
